import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    width: '100%',
    minWidth: 0,
    overflow: 'hidden',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  label: {
    fontSize: tokens.fontSizeBase100,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
  },
  treeContainer: {
    padding: tokens.spacingHorizontalL,
    backgroundColor: tokens.colorNeutralBackground6,
    color: tokens.colorNeutralForeground1,
    borderRadius: tokens.borderRadiusMedium,
    overflowX: 'auto',
    fontFamily: "'Cascadia Code', 'Consolas', monospace",
    fontSize: tokens.fontSizeBase200,
    lineHeight: '20px',
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    margin: 0,
    userSelect: 'text',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'pre',
    minHeight: '20px',
    borderRadius: tokens.borderRadiusSmall,
  },
  rowHover: {
    backgroundColor: tokens.colorNeutralBackground3,
  },
  toggle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '14px',
    height: '14px',
    cursor: 'pointer',
    color: tokens.colorNeutralForeground3,
    border: 'none',
    backgroundColor: 'transparent',
    padding: '0',
    marginRight: '2px',
    flexShrink: 0,
  },
  spacer: {
    display: 'inline-block',
    width: '16px',
    flexShrink: 0,
  },
  copyBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '20px',
    height: '18px',
    marginLeft: tokens.spacingHorizontalXS,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusSmall,
    backgroundColor: tokens.colorNeutralBackground2,
    cursor: 'pointer',
    color: tokens.colorNeutralForeground2,
    padding: '0',
    flexShrink: 0,
  },
  keyName: {
    color: tokens.colorPaletteBlueForeground2,
  },
  stringVal: {
    color: tokens.colorPaletteGreenForeground1,
  },
  numberVal: {
    color: tokens.colorPaletteBlueForeground2,
  },
  boolVal: {
    color: tokens.colorPaletteMarigoldForeground1,
  },
  nullVal: {
    color: tokens.colorNeutralForeground3,
  },
  collapsedSummary: {
    color: tokens.colorNeutralForeground3,
    fontStyle: 'italic',
  },
  toolbarActions: {
    display: 'flex',
    gap: '4px',
  },
});
